const env = process.env.REACT_APP_ENV || "development"; // Default to 'development' if not set

const baseURLs = {
  development: process.env.REACT_APP_API_BASE_URL_DEVELOPMENT,
  staging: process.env.REACT_APP_API_BASE_URL_STAGING,
  production: process.env.REACT_APP_API_BASE_URL_PRODUCTION,
};

const baseConfig = {
  api: {
    baseURL: baseURLs[env] || baseURLs.development, // Fallback to development if the environment is unknown
  },
};

export default baseConfig;
